import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscFiltersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 18 10" {...props}>
    <path
      fill="currentColor"
      d="M17 2H1a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zm-4 4H5a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zM8 9a1 1 0 1 1 1 1z"
    />
  </svg>
);
